var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"local-tradingview"},[_c('div',{staticClass:"kline d-none",attrs:{"id":"chart_wrapper"}},[_c('div',{attrs:{"id":"tv_chart_container"}})])])
}]

export { render, staticRenderFns }